/**
 * @fileoverview The choices the sort and filter sheet offers, with the key naming each,
 * shared with the toolbar so a chip is named the way the sheet names it.
 *
 * Where: PlantFilterSheet and PlantToolbar.
 * API: none.
 * Settings: none.
 * Words (en/es): plants.toolbar.* (sortAttention, sortRecent, sortName,
 * sortStage, sortLocation, statusActive, statusArchived, statusAll,
 * dateAny, date30, date90, dateThisYear, dateLastYear, dateCustom).
 *
 * @module plantFilterOptions
 */

import type { DateRangePreset, PlantSort, PlantStatusFilter } from '../lib/plantViews';

/** The orders offered. First, and the default: the garden in the order it needs you. */
export const SORTS: Array<{ value: PlantSort; key: string }> = [
  { value: 'attention', key: 'plants.toolbar.sortAttention' },
  { value: 'recent', key: 'plants.toolbar.sortRecent' },
  { value: 'name', key: 'plants.toolbar.sortName' },
  { value: 'stage', key: 'plants.toolbar.sortStage' },
  { value: 'location', key: 'plants.toolbar.sortLocation' },
];

/** Which plants to show: the garden, the archive, or both. The garden is the default. */
export const STATUSES: Array<{ value: PlantStatusFilter; key: string }> = [
  { value: 'active', key: 'plants.toolbar.statusActive' },
  { value: 'archived', key: 'plants.toolbar.statusArchived' },
  { value: 'all', key: 'plants.toolbar.statusAll' },
];

/** How far back the garden is narrowed to (see dateBounds); Custom asks for two dates. */
export const DATE_RANGES: Array<{ value: DateRangePreset; key: string }> = [
  { value: 'any', key: 'plants.toolbar.dateAny' },
  { value: 'days30', key: 'plants.toolbar.date30' },
  { value: 'days90', key: 'plants.toolbar.date90' },
  { value: 'thisYear', key: 'plants.toolbar.dateThisYear' },
  { value: 'lastYear', key: 'plants.toolbar.dateLastYear' },
  { value: 'custom', key: 'plants.toolbar.dateCustom' },
];
